var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-layout',[_c('div',{staticClass:"flex flex-col items-center justify-center text-center min-h-screen"},[_c('h1',{staticClass:"font-bold text-4xl mb-10"},[_vm._v("404 Not Found")]),_vm._v(" "),_c('img',{attrs:{"src":"https://atypicdev.com/cms/404.webp","alt":"Not Found"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }